/**
 * Created by Ram on 19/09/2016.
 */

import React, { Component, Fragment } from 'react';
import { Link } from '@reach/router'
import Header from './header'

export default class Dashboard extends Component {

    componentDidUpdate(prevProps) {
        if (prevProps.location.href !== this.props.location.href) {
            window.scrollTo(0, 0)
        }
    }

    render() {
        return (
            <Fragment>
                <Header />
                <div className="container-fluid mainContentBody">
                    <div className="mainDiv">
                        <nav className="navbar navbar-inverse admin-top-nav">
                            <div className="container-fluid">
                                <ul className="nav navbar-nav row admin-portal-nav">
                                    <li className="col-lg-2 col-sm-3"><Link to="generalStats"><span className="glyphicon glyphicon-signal"></span> GENERAL STATS</Link></li>
                                    <li className="col-lg-2 col-sm-3"><Link to="/"><span className="glyphicon glyphicon-user"></span> ACCOUNTS</Link></li>
                                    <li className="col-lg-2 col-sm-3"><Link to="/users/createAdminUser"><span className="glyphicon glyphicon-globe"></span> BLUECONNECT USERS</Link></li>
                                </ul>
                            </div>
                        </nav>
                        { this.props.children }
                    </div>
                </div>
            </Fragment>
        )
    }
}
